import { render } from "./SuccessfulRegistration.vue?vue&type=template&id=76e6c196"
import script from "./SuccessfulRegistration.vue?vue&type=script&lang=js"
export * from "./SuccessfulRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__